module.exports = __webpack_public_path__ + "img/Ativo 10.8a018244.png";